export const DoubleDash = () => <>&ndash;&ndash;</>;
